const formatter = new Intl.NumberFormat("ru-RU");

export function formatNumber(n: number): string {
  return formatter.format(n);
}

const pluralRules = new Intl.PluralRules("ru-RU");

export function pluralize(n: number, forms: { one: string; few: string; many: string }): string {
  const rule = pluralRules.select(n);
  if (rule === "one") return forms.one;
  if (rule === "few") return forms.few;
  return forms.many;
}

export function getOldPrice(price: number, discount: number): number {
  if (discount <= 0 || discount >= 100) return price;
  return Math.round(price / (1 - discount / 100));
}
